module.exports = __webpack_public_path__ + "smile.189bb349.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/smile.svg
// module id = iId9
// module chunks = 1